import { finalize } from 'rxjs/operators';
import { Component, Injector, OnInit, } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ContactUsServiceProxy, GetContactUsForHomeViewDto, UserSubmissionServiceProxy, CreateUserSubmissionDto, UserSubmissionCategory } from '@shared/service-proxies/service-proxies';
import * as Lf from "leaflet";
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'seek-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  animations: [appModuleAnimation()]
})
export class ContactUsComponent extends AppComponentBase implements OnInit {
  map: Lf.Map;
  pendingCoords: { lat: number; lng: number } | null = null;
  homeCoords = {
    lat: 24.7111266,
    lon: 46.682359
  };

  selectedAction: string | null = null;
  suggestions: string | null = null;
  selectedCategoryLabel: string | null = null;

  selectAction(label: string): void {
    this.selectedAction = label;
  }

  selectSuggestions(label: string): void {
    this.suggestions = label;
  }

  popupText = "مقر المركز";

  markerIcon = {
    icon: Lf.icon({
      iconSize: [25, 41],
      iconAnchor: [10, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "/assets/common/images/marker-icon.png",
      shadowUrl: "/assets/common/images/marker-shadow.png"
    })
  };

  options = {
    layers: [
      Lf.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 15,
        minZoom: 5,
        attribution: ""
      })
    ],
    zoom: 18,
    zoomControl: false,
    center: Lf.latLng(this.homeCoords.lat, this.homeCoords.lon)
  };
  viewContactUs: GetContactUsForHomeViewDto = new GetContactUsForHomeViewDto();
  useMap = AppConsts.useMapInContactUs;
  constructor(injector: Injector,
    private _contactusServiceProxy: ContactUsServiceProxy,
    private _userSubmissionService: UserSubmissionServiceProxy) {
    super(injector);
  }


  ngOnInit() {
    this._contactusServiceProxy.getPublished().pipe(finalize(() => { })).subscribe((contactusResult) => {
      this.viewContactUs = contactusResult;
      const lat = this.viewContactUs.contactUs?.centerLoctionLatitude;
      const lng = this.viewContactUs.contactUs?.centerLoctionLongitude;
      if (this.map) {
        // Map already ready — apply immediately
        this.setMarkers(lat, lng);
        this.map.dragging.disable();
      } else {
        // Map not ready yet — store coords for onMapReady
        this.pendingCoords = { lat, lng };
      }
    });
  }
  setMarkers(lat, lng) {
    const popupInfo = `<a  href="https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=18/${lat}/${lng}" target="_blank" ><b style="color: #297D59; background-color: white">${this.popupText
      }</b></a>`;
    Lf.marker([lat, lng], this.markerIcon)
      .addTo(this.map).bindPopup(popupInfo, { closeButton: false }).openPopup();
    this.map.panTo(Lf.latLng(lat, lng));
  }

  onMapReady(map: Lf.Map) {
    this.map = map;
    this.map.dragging.disable();
    // Apply markers if API data arrived before the map was ready
    if (this.pendingCoords) {
      this.setMarkers(this.pendingCoords.lat, this.pendingCoords.lng);
      this.pendingCoords = null;
    }
  }

  submission: CreateUserSubmissionDto = new CreateUserSubmissionDto();

  submit(): void {
    if (!this.submission.fullName || !this.submission.fullName.trim()) {
      this.message.warn('الرجاء إدخال الاسم بالكامل');
      return;
    }

    if (!this.submission.email || !this.submission.email.trim()) {
      this.message.warn('الرجاء إدخال البريد الإلكتروني');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (this.submission.email && !emailRegex.test(this.submission.email)) {
      this.message.warn('الرجاء إدخال بريد إلكتروني صحيح');
      return;
    }

    if (!this.submission.phoneNumber || !this.submission.phoneNumber.trim()) {
      this.message.warn('الرجاء إدخال رقم الجوال');
      return;
    }

    if (!this.submission.subject || !this.submission.subject.trim()) {
      this.message.warn('الرجاء إدخال الموضوع');
      return;
    }

    if (!this.submission.message || !this.submission.message.trim()) {
      this.message.warn('الرجاء إدخال نص الرسالة');
      return;
    }

    if (!this.submission.category) {
      this.message.warn('الرجاء اختيار الفئة');
      return;
    }

    if (this.submission.fullName && this.submission.fullName.length > 200) {
      this.message.warn('الاسم يجب ألا يتجاوز 200 حرف');
      return;
    }

    if (this.submission.email && this.submission.email.length > 200) {
      this.message.warn('البريد الإلكتروني يجب ألا يتجاوز 200 حرف');
      return;
    }

    if (this.submission.phoneNumber && this.submission.phoneNumber.length > 10) {
      this.message.warn('رقم الجوال يجب ألا يتجاوز 10 أرقام');
      return;
    }

    if (this.submission.subject && this.submission.subject.length > 200) {
      this.message.warn('الموضوع يجب ألا يتجاوز 200 حرف');
      return;
    }

    if (this.submission.message && this.submission.message.length > 500) {
      this.message.warn('الرسالة يجب ألا تتجاوز 500 حرف');
      return;
    }

    this._userSubmissionService.submit(this.submission)
      .pipe(finalize(() => { }))
      .subscribe(() => {
        this.notify.success(this.l('تم العمليه بنجاح'));
        this.submission = new CreateUserSubmissionDto();
        this.selectedAction = null;
        this.selectedCategoryLabel = null;
      });
  }



  selectSubmissionCategory(category: any, label: string): void {
    this.submission.category = category;
    this.selectedCategoryLabel = label;
  }
}
